export default "__VITE_ASSET__ffa649e9__"